import "../_components/accordion/accordion.js";
import "../_components/_vendors/powerReviews/load-powerreviews"
import "../_components/product/envSortingLogic";
import shareableLinkFeature from "../_components/product/product-shareableLinkFeature";
import "../_components/_utilities/globalDialogClose";
import "../_components/product/template-product";
import "../_components/carousel/carousel.js";
import "../_components/legacyModal/legacyModal";
import "../_components/product/ResponsiveVideo";
import "../_components/product/videoPlayPause.js";
import "../_components/product/gtagEvents.js";
import windowClingCalc from "../_components/product/windowClingsCalc.js";
import "../_components/_vendors/clickStream/clickstreamInit.js"
import "../_components/product/helpTips.js";
import "../_components/productSelectContainer/productConfigSelect.js";
import Modal from "../_components/modal/Modal.js";
import FilePrepModalController from "../_components/product/FilePrepModalController.js";
import ShippingEstimateController from "../_components/shipping/ShippingEstimateController.js";
import shippingEstimateProductPageTitleHtml from "../_components/shipping/shippingEstimateProductPageTitle.hbs"

document.body.classList.add(document.querySelector('.js-productName').innerText.replace(/&/g,"").replace(/--/g,"-").replace(/\s+/g, '-').toLowerCase());

document.querySelectorAll('.js--action-filePrepButton')?.forEach(link => {
    link.addEventListener('click', (e)=>{
        const modal = new Modal({
            title: `<h3 class="hdg hdg_5" style="font-weight: 700; border-bottom: none;">File Prep Guide</h3>`,
            classes: ['globalDialog_wide'],
            controller: FilePrepModalController
        });
    });
});

let state = {
    loggedIn: false,
    cart: {}
}

Promise.allSettled([
    Collaterate.User.getUser(),
    Collaterate.Project.getCart(),
])
    .then(([user, cart]) => {
        state.loggedIn = Boolean(user.value);
        state.cart = cart.value;
    })
    .then(() => {
        document.querySelector('.js--action-estimateShipping')?.addEventListener('click', handleShippingEstimateClick);
    });

const productTemplateLogic = {
    onCalcLoaded: () => {
        shareableLinkFeature();
        windowClingCalc.init();
        document.body.classList.contains('paper-sample-book') && paperSampleBookMods();
    },
    onQuoteUpdated: () => {
    },
}

function paperSampleBookMods () {
    document.querySelector('#quantity').remove();
    document.querySelector('.addToCart').classList.add('btn', 'btn_cta');
}

function handleShippingEstimateClick () {
    const modal = new Modal({
        title: shippingEstimateProductPageTitleHtml(),
        classes: ['globalDialog_wide'],
        controller: ShippingEstimateController,
        controllerInject: [state.cart, state.loggedIn, false, true],
    });
}

window.configureEvents.registerOnCalcLoadedListener(productTemplateLogic);
window.configureEvents.registerOnQuoteUpdatedListener(productTemplateLogic);